import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TpETLComponentTypeManifest } from '../interfaces';
import { VALTYPES } from '../../../../data/interfaces';
import { TpETLObjectTypes } from '../../etl-data-types/interfaces';
import { color } from '../../../visual-analytics/helpers/colors';
import { TpETLPipelineComponent, TpETLDryRun, TpETLDryRunComponentResult } from '../../interfaces';
import { copyETLDryRunObjectTableColumns, ETLDryRunObjectTableAddColumn } from '../utils';
import { addDryRunObjectTable, getETLComponentInputObjectTable } from '../../utils';

function performDryRun(dryRun: TpETLDryRun, comp: TpETLPipelineComponent): TpETLDryRunComponentResult {
  const inputTableObj = getETLComponentInputObjectTable(dryRun, comp, 'sourceTable');
  const outputTableObj = addDryRunObjectTable(dryRun, comp.outputObjectIds['result'], comp);
  // getETLComponentInputObject(dryRun, comp, )
  copyETLDryRunObjectTableColumns(inputTableObj, outputTableObj);

  ETLDryRunObjectTableAddColumn(
    outputTableObj,
    'mentioned_genes',
    'Mentioned Genes',
    'The list of mentioned genes in the publication',
    VALTYPES.MULTICAT,
  );
  ETLDryRunObjectTableAddColumn(
    outputTableObj,
    'mentioned_variants',
    'Mentioned Variants',
    'The list of mentioned variants in the publication',
    VALTYPES.MULTICAT,
  );
  ETLDryRunObjectTableAddColumn(
    outputTableObj,
    'mentioned_diseases',
    'Mentioned Diseases',
    'The list of mentioned diseases in the publication',
    VALTYPES.MULTICAT,
  );
  ETLDryRunObjectTableAddColumn(
    outputTableObj,
    'mentioned_chemicals',
    'Mentioned Chemicals',
    'The list of mentioned chemicals in the publication',
    VALTYPES.MULTICAT,
  );
  ETLDryRunObjectTableAddColumn(
    outputTableObj,
    'mentioned_species',
    'Mentioned Species',
    'The list of mentioned species in the publication',
    VALTYPES.MULTICAT,
  );

  return {
    abort: false,
  };
}

export const manifestETLQueryPubTator: TpETLComponentTypeManifest = {
  id: 'QueryPubTator',
  name: 'Query PubTator',
  description: 'Get PubTator correlations for Pubmed articles',
  categoryId: 'source',
  color: color(0, 128, 255),
  icon: <FontAwesomeIcon icon={['fas', 'book']} />,
  inputs: [
    {
      type: TpETLObjectTypes.TABLE,
      id: 'sourceTable',
      name: 'Source Table',
      columns: [],
    },
  ],
  outputs: [
    {
      id: 'result',
      name: 'Result table',
      type: TpETLObjectTypes.TABLE,
      description: 'Table with the retrieved publications',
      columns: [],
    },
  ],
  params: [],
  performDryRun,
};
